import './App.css';
import { Routes, Route, } from 'react-router-dom';
import { Home } from './pages/Home.jsx';
import  Guest  from './pages/Guest.jsx';
import  Staff  from './pages/Staff.jsx';
import  CheckInOut  from './pages/CheckInOut.jsx';
import  Confirmation  from './pages/Confirmation.jsx';
import  NewGuest  from './pages/NewGuest.jsx';



import  AuthCallback  from './auth/AuthCallback.jsx';


import AuthProviderWithHistory from './auth/AuthProviderWithHistory.jsx';
import { AuthProvider } from './contexts/AuthContext.jsx';
import PrivateRoute from './auth/PrivateRoute.jsx';
import {Header} from "./components/Header.jsx";


function App() {

    return (
        <div className="w-full mx-auto h-screen  bg-lightgrey">

            <AuthProviderWithHistory>
                <AuthProvider>
                    <Header></Header>
                    <Routes>
                        <Route path="/authcallback" element={<AuthCallback />} />
                        <Route
                            path="/login"
                            element={
                                <PrivateRoute>
                                    <Home />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/"
                            element={
                                <PrivateRoute>
                                    <Home />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/guest"
                            element={
                                <PrivateRoute>
                                    <Guest />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/staff"
                            element={
                                <PrivateRoute>
                                    <Staff />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/checkin-out"
                            element={
                                <PrivateRoute>
                                    <CheckInOut />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/confirmation"
                            element={
                                <PrivateRoute>
                                    <Confirmation />
                                </PrivateRoute>
                            }
                        />
                        <Route
                            path="/new-guest"
                            element={
                                <PrivateRoute>
                                    <NewGuest />
                                </PrivateRoute>
                            }
                        />
                    </Routes>

                </AuthProvider>
            </AuthProviderWithHistory>
        </div>
    );
}

export default App;
